var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';

import { FeatureToggle } from "../../components/Elements/FeatureToggle";
import SelectFilter from "../../Library/components/SelectFilter";
import FormGroup from "../../DocumentForm/components/FormGroup";
import { t } from "../../I18N";
import { NeedAuthorization } from "../../Auth";






const filteredAggregation = (aggregations, key) => {var _aggregations$all, _aggregations$all$gen;
  const bucket = ((aggregations === null || aggregations === void 0 ? void 0 : (_aggregations$all = aggregations.all) === null || _aggregations$all === void 0 ? void 0 : (_aggregations$all$gen = _aggregations$all.generatedToc) === null || _aggregations$all$gen === void 0 ? void 0 : _aggregations$all$gen.buckets) || []).find((a) => a.key === key) || {
    filtered: { doc_count: 0 }
  };
  return bucket.filtered.doc_count;
};

const options = (aggregations = { all: {} }) => [
{
  label: t('System', 'Automatically generated'),
  value: true,
  results: filteredAggregation(aggregations, 'true')
},
{
  label: t('System', 'Reviewed'),
  value: false,
  results: filteredAggregation(aggregations, 'false')
}];


export const FilterTocGeneration = ({ onChange, aggregations }) => /*#__PURE__*/
_jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
_jsx(FeatureToggle, { feature: "tocGeneration" }, void 0, /*#__PURE__*/
_jsx(FormGroup, { className: "admin-filter" }, "generatedToc", /*#__PURE__*/
_jsx(SelectFilter, {
  model: ".customFilters.generatedToc",
  prefix: "generatedToc",
  label: t('System', 'Automatic Table of Contents'),
  onChange: onChange
  //@ts-ignore from the update typescript from 5.6.2 to 5.6.3
  , options: options(aggregations),
  showBoolSwitch: false }
)
)
)
);